import React from 'react';
import '@fontsource/montserrat'; 
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/700.css';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import VisitingCard from './visiting-card/VisitingCard';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0c4d8f',
      light: '#3a74b8',
      dark: '#002a5e',
    },
    background: {
      default: '#f5f7fa',
    },
    text: {
      primary: '#2c3e50',
      secondary: '#546e7a',
    },
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <VisitingCard />
    </ThemeProvider>
  </React.StrictMode>
);